const UserActionTypes = Object.freeze({
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  DELETE_USER_FACEBOOK_DATA: 'user/DELETE_FACEBOOK_DATA',
  SEND_EMAIL_CONFIRMATION_FOR_DELETION: 'user/SEND_EMAIL_CONFIRMATION_FOR_DELETION',
  LOGOUT: 'user/LOGOUT',
  GRANT_ADMIN_ROLE: 'user/GRANT_ADMIN_ROLE',
  REVOKE_ADMIN_ROLE: 'user/REVOKE_ADMIN_ROLE',
});

export default UserActionTypes;
